<template>
  <rfq>
    <div class="cust-travel-wrap guest-quote-page">
      <travel-plan-select-page channel="customer" :guest="true" />
    </div>
  </rfq>
</template>

<script>
import Rfq from '@/components/layout/Rfq';
import TravelPlanSelectPage from '@/components/travel/TravelPlanSelectPage';

export default {
  name: 'GuestTravelPlanSelect',
  components: { Rfq, TravelPlanSelectPage },
  metaInfo: { title: 'Travel Insurance — Get a quote' },
};
</script>

<style src="@/assets/css/customer-travel.css"></style>
<style scoped>
.guest-quote-page {
  padding-top: 8px;
  padding-bottom: 32px;
}
</style>
